import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../admin/components/Header";
import Footer from "../admin/components/Footer";
import BillingBanner from "../admin/components/BillingBanner";
import { isSuspended, refreshBilling } from "../admin/components/Features";
import styles from "../admin/components/layout.module.css";

// Billing (add-ons, open invoices) is re-read once per page load so staff see
// changes made by the company admin or the platform without signing in again
let billingRefreshed = false;

const AdminLayout = ({ children }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!billingRefreshed) {
      billingRefreshed = true;
      refreshBilling().then((auth) => {
        const open = ["/my-profile", "/company-profile", "/account-suspended"];
        if (auth && isSuspended(auth) && open.indexOf(location.pathname) === -1) {
          navigate("/account-suspended", { replace: true });
        }
      });
    }
  }, [navigate, location.pathname]);

  return (<>
    <div className={styles.DashboardMainBody}>
      <Header onMenuToggle={() => setMobileNavOpen((prev) => !prev)} />
      <Footer
        menuName={children?.props?.menuName}
        mobileOpen={mobileNavOpen}
        onClose={() => setMobileNavOpen(false)}
      />
      <div className={styles.ContentArea}>
        <BillingBanner />
        {children}
      </div>
    </div>
  </>);
};

export default AdminLayout;
